(function () {
  'use strict';

  var DEBUG_ALERTS = false;
  angular.module('wsLrs.controllers').controller('AlertsCtrl', ['$scope', '$rootScope', '$interval', 'Alerts', function AlertsCtrl($scope, $rootScope, $interval, Alerts) {
    Alerts.startAlertsPolling();
    $scope.alerts = [];
    Alerts.fetchAlerts().then(function (alerts) {
      $scope.alerts = alerts;
    });
    $scope.dismissAlert = function dismissAlert(alert) {
      Alerts.markAsRead(alert);
    };
    var removeAlertReceivedListener = $rootScope.$on('alert-received', function (evt, alert) {
      $scope.alerts.push(alert);
    });
    $scope.$on('$destroy', removeAlertReceivedListener);

    // Testing code
    if (DEBUG_ALERTS === true) {
      $interval(function () {
        Alerts.raiseAlert({
          "type": "info",
          "text": "The current time is " + new Date().toISOString()
        });
      }, 1000 * 10);
    }
  }]);
})();
